angular.module('modeOfRecognition.components', [])
    .component("modeOfRecognition", {
        templateUrl: "ng/components/modeOfRecognition/modeOfRecognition.view.html",
        bindings: {
            selectedValue: '&?',
            //variable of binding
        },
        controllerAs: 'modeOfRecognitionCtrl',
        controller: function modeOfRecognitionController() {
            var self = this;

            self.$onInit = function () {
                self.modRiconoscimento = "";
                self.inputData = [{
                        item: 'SPID'
                    },
                    {
                        item: 'WEBCAM'
                    }
                ]
            }

            self.onChange = function (item) {
                self.modRiconoscimento = item.item;
                self.selectedValue({
                    item: item
                });
            }
        }
    });